export const PAGE_SIZE = Number(process.env.REACT_APP_PAGE_SIZE);
